import { render, staticRenderFns } from "./CoursePagePreview.vue?vue&type=template&id=770e354a&scoped=true"
import script from "./CoursePagePreview.vue?vue&type=script&lang=js"
export * from "./CoursePagePreview.vue?vue&type=script&lang=js"
import style0 from "./CoursePagePreview.vue?vue&type=style&index=0&id=770e354a&prod&lang=scss"
import style1 from "./CoursePagePreview.vue?vue&type=style&index=1&id=770e354a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e354a",
  null
  
)

export default component.exports